export default {
  user: null,
  scale: 100,
  screenSize: 4,
  educationResults: false,
  pendingReviews: [],
};
